import {ViewAsStorageKey} from '../constants/ViewAsStorageKey'
import {DefaultViewAsState} from '../constants/DefaultViewAsState'
import {IViewAsState} from '../types/IViewAsState'

export function readViewAsStateFromStorage(): IViewAsState {
  if(typeof sessionStorage === 'undefined') {
    return {...DefaultViewAsState}
  }
  try {
    const raw = sessionStorage.getItem(ViewAsStorageKey)
    if(!raw) {
      return {...DefaultViewAsState}
    }
    const parsed = JSON.parse(raw) as Partial<IViewAsState>
    return {
      ...DefaultViewAsState,
      ...parsed,
    }
  } catch {
    return {...DefaultViewAsState}
  }
}
